(() => {
  const section = document.querySelector('[data-honey-gift-card-section]');
  if (!section) return;
  const form = section.querySelector('.honey-gift-card__form');
  if (!form) return;

  const preview = section.querySelector('[data-gift-card-preview-image]');
  const previewKicker = section.querySelector('[data-gift-card-preview-kicker]');
  const previewAmount = section.querySelector('[data-gift-card-preview-amount]');
  const previewRecipient = section.querySelector('[data-gift-card-preview-recipient]');
  const variantInput = form.querySelector('[data-gift-card-variant-id]');
  const occasionProperty = form.querySelector('[data-gift-card-occasion]');
  const designProperty = form.querySelector('[data-gift-card-design]');
  const amountProperty = form.querySelector('[data-gift-card-amount]');
  const status = form.querySelector('[data-gift-card-status]');
  const designHint = form.querySelector('[data-design-hint]');
  const categoryInputs = [...form.querySelectorAll('[data-category-choice]')];
  const designInputs = [...form.querySelectorAll('[name="gift-card-design-choice"]')];
  const designGroups = [...form.querySelectorAll('[data-design-group]')];
  const amountInputs = [...form.querySelectorAll('[data-fixed-amount]')];

  const sortByAdminOrder = (container, selector) => {
    [...container.querySelectorAll(selector)]
      .sort((a, b) => Number(a.dataset.sortOrder || 999) - Number(b.dataset.sortOrder || 999))
      .forEach((node) => container.appendChild(node));
  };
  sortByAdminOrder(form.querySelector('.honey-gift-card__categories'), '[data-occasion-option]');
  sortByAdminOrder(form.querySelector('.honey-gift-card__designs'), '[data-design-group]');

  const selectDesign = (input) => {
    if (!input) return;
    input.checked = true;
    designProperty.value = input.dataset.designName || '';
    if (previewKicker) previewKicker.textContent = input.dataset.designName || '';
    if (preview && input.dataset.designImage) preview.src = input.dataset.designImage;
  };

  const applyOccasion = () => {
    const occasion = form.querySelector('[data-category-choice]:checked');
    const handle = occasion?.value || '';
    occasionProperty.value = occasion?.dataset.categoryName || '';
    let visible = [];
    designGroups.forEach((group) => {
      const show = group.dataset.designOccasion === handle;
      group.hidden = !show;
      if (show) visible.push(group.querySelector('input'));
    });
    const selected = visible.find((input) => input.checked) || visible[0];
    selectDesign(selected);
    if (designHint) designHint.textContent = visible.length ? `${visible.length} design${visible.length === 1 ? '' : 's'} available` : 'No designs in this occasion yet';
  };

  const selectAmount = (input) => {
    const variantId = input?.dataset.variantId || '';
    variantInput.value = variantId;
    variantInput.disabled = !variantId;
    amountProperty.value = `SAR ${input?.value || ''}`;
    previewAmount.textContent = `SAR ${input?.value || ''}`;
    status.textContent = variantId ? '' : 'This amount needs its matching Shopify Gift Card variant.';
  };

  categoryInputs.forEach((input) => input.addEventListener('change', applyOccasion));
  designInputs.forEach((input) => input.addEventListener('change', () => selectDesign(input)));
  amountInputs.forEach((input) => input.addEventListener('change', () => selectAmount(input)));

  const recipient = form.querySelector('[data-recipient-name]');
  recipient?.addEventListener('input', () => { previewRecipient.textContent = recipient.value.trim() || 'For someone special'; });
  const sendDate = form.querySelector('[data-send-date]');
  if (sendDate) sendDate.min = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);

  applyOccasion();
  selectAmount(form.querySelector('[data-fixed-amount]:checked'));
})();
